import React, { useState, memo } from "react";
import SettingsModal from "../../../Modal/SettingsModal";
import { Button } from "../../../BP2Components";
import "./kanban.less";
import FormComplete from "../../../FormsV2/FormComplete";
import { mobileStartActionByUrl, mobileStartFlutterActionByUrl } from "../../../../util/Scripts";
import IntlMessages from "@util/IntlMessages";
import { KanbanScripts } from "./KanbanScripts";
import { getForm } from "../../../../services/restAPI/RestApi";
import ItemContent from "./ItemContent";
import ActionsDropdown from "../../../ActionsDropdown/ActionsDropdown";

const KanbanItem = memo(
   ({
      itemValue,
      settings,
      columns,
      saveItemValue,
      displayFormChildId,
      rows,
      setRows,
      actionButtons,
      previewItemFormChildId,
   }) => {
      const saveChangesFromForm = (recordId) => {
         let newItem = {};

         getForm(displayFormChildId, recordId).then((res) => {
            const responseElements = Object.values(
               res.data.default.mainForm.forms_data.tab[0].elements,
            );

            columns.map(({ techName, enumType, values, precision }) => {
               const responseElement = responseElements.find(
                  (responseElement) => responseElement.tech_name === techName,
               );

               if (values?.length > 0) {
                  newItem[KanbanScripts.getTitleFromTechName(techName, columns) || techName] = {
                     id: responseElement.value,
                     value:
                        Object.values(
                           values.find?.((elem) => Object.keys(elem)[0] == responseElement.value) ||
                              {},
                        )?.[0] || "",
                  };
               } else if (enumType === "int" || enumType === "dec") {
                  newItem[KanbanScripts.getTitleFromTechName(techName, columns) || techName] =
                     parseFloat(responseElement.value).toFixed(
                        enumType === "dec" ? precision : 0,
                     ) || 0;
               } else {
                  newItem[KanbanScripts.getTitleFromTechName(techName, columns) || techName] =
                     responseElement.value || "";
               }
            });

            newItem.key = rows.find((row) => row.recordId == recordId)?.key;
            newItem.recordId = recordId;

            setRows([...rows.filter((row) => row.recordId != recordId), newItem]);
         });
      };
      return (
         <div className={"kanban-item kanban-item-" + itemValue.recordId}>
            <div className={"kanban-item-content kanban-item-" + itemValue.recordId}>
               {settings.itemContent.map((row, rowIndex) => (
                  <>
                     <div
                        className={"kanban-item-row allow-select kanban-item-" + itemValue.recordId}
                        key={rowIndex}
                     >
                        {row.columns.map((column, columnIndex) => {
                           const width = Math.floor(95 / row.columns.length) + "%"; // For now I'm leaving width as it is, in future updates it could be changed.
                           return (
                              <>
                                 <ItemContent
                                    itemValue={itemValue}
                                    key={columnIndex}
                                    columnTechName={column.columnTechName}
                                    showColumnName={column.showColumnName}
                                    width={width}
                                    columns={columns}
                                    saveItemValue={saveItemValue}
                                 />
                                 {columnIndex + 1 !== row.columns.length ? (
                                    <div
                                       className={
                                          "kanban-item-content-separator kanban-item-" +
                                          itemValue.recordId
                                       }
                                       style={{ borderColor: "var(--second)" }}
                                    ></div>
                                 ) : null}
                              </>
                           );
                        })}
                     </div>
                     {settings.itemContent.length > 1 &&
                     settings.itemContent.length - 1 > rowIndex ? (
                        <hr
                           className={"kanban-item-" + itemValue.recordId}
                           style={{ borderColor: "var(--second)" }}
                        />
                     ) : null}
                  </>
               ))}
            </div>
            {previewItemFormChildId !== 0 && itemValue?.recordId ? (
               <div className="edit-icon">
                  <SettingsModal
                     widgetId={settings.id}
                     icon={previewItemFormChildId !== 0 ? "edit" : null}
                     deleteIcon="false"
                     initialWidth={1000}
                     children={
                        <>
                           <div
                              className="action-buttons"
                              style={{ padding: 10, margin: 0, borderBottom: "1px solid #E8E8E8" }}
                           >
                              <ActionsDropdown
                                 actions={actionButtons}
                                 rowData={itemValue}
                                 rowId={itemValue?.recordId}
                                 saveCallback={saveChangesFromForm}
                              />
                           </div>
                           <FormComplete
                              formId={previewItemFormChildId}
                              dataId={itemValue?.recordId}
                              saveCallback={saveChangesFromForm}
                           />
                        </>
                     }
                  />
               </div>
            ) : null}
         </div>
      );
   },
);

export default KanbanItem;
